import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { GetSubscriptionSetData } from "../../../../../Api/ServiceDatas";
import { useApi } from "../../../../../hooks/useApi";
import { authType } from "../../../../../pages/Login";
import LineBtn from "../../../../Button/LineBtn";
import LineBox from "../../../../DefaultStyles/LineBox";
import Loader from "../../../../DefaultStyles/Loader";
import Pagination from "../../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../../Table/Table";
import { ChatSection, ChatSectionTitle } from "../ChatSearch/ChatSearchResult";
import ChatReportDetailModal from "./OldChatReportDetailModal";
import { getSubsNameBySubsId3 } from "../../../../../AdminApi/3.0_utils";

export interface IChatReportComplete {
  key: string;
  msgList: string[];
  uid: {
    name: string;
    nickname: string;
    uid: string;
  };
  party: {
    partyid: string;
    servsubsid: number;
  };
  reason: string;
  reasonid: number;
  target: {
    uid: string;
    name: string;
    nickname: string;
  };
  time: string;
  owner: number;
  comptime: string;
}

export default function OldReportComplete() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [reportCompleteList, setReportCompleteList] = useState<
    IChatReportComplete[]
  >([]);
  const [reportDetailModal, setReportDetailModal] = useState(false);
  const [detailData, setDetailData] = useState<IChatReportComplete>({
    key: "",
    msgList: [],
    uid: {
      name: "",
      nickname: "",
      uid: "",
    },
    party: {
      partyid: "",
      servsubsid: 0,
    },
    reason: "",
    reasonid: 0,
    target: {
      uid: "",
      name: "",
      nickname: "",
    },
    time: "",
    comptime: "",
    owner: 0,
  });

  const { response, loading } = useApi({
    method: "get",
    url: auth?.chat ? `oldchat/report?iscomp=1&page=init&size=10` : undefined,
  });

  console.log(response);

  const reportCompleteTableHead = [
    "신고자",
    "PID",
    "Subscription",
    "사유 구분",
    "신고 일시",
    "처리 완료 일시",
    "보기",
  ];

  useEffect(() => {
    if (response?.status === 200 && response?.data?.list?.length > 0) {
      setReportCompleteList(response?.data?.list?.reverse());
    }
  }, [response]);

  return (
    <ChatSection>
      <ChatSectionTitle>신고 처리 완료</ChatSectionTitle>

      <LineBox>
        <Table tableHeadData={reportCompleteTableHead}>
          <>
            {reportCompleteList?.map(
              (d: IChatReportComplete, index: number) => {
                return (
                  <TableBody key={index}>
                    <TableBodyItem
                      clickable={true}
                      onClick={() => navigate(`/users/info/${d?.uid?.uid}`)}
                    >
                      {d?.uid?.uid}_{d?.uid?.name}_{d?.uid?.nickname}
                    </TableBodyItem>
                    <TableBodyItem
                      clickable={true}
                      onClick={() =>
                        navigate(`/party/info/${d?.party?.partyid}`)
                      }
                    >
                      {d?.party?.partyid}
                    </TableBodyItem>
                    <TableBodyItem>
                      {d?.party?.servsubsid}_
                      {getSubsNameBySubsId3(d?.party?.servsubsid)}
                    </TableBodyItem>
                    <TableBodyItem>{d?.reason}</TableBodyItem>
                    <TableBodyItem>
                      {dayjs(d?.time)?.format("YYYY-MM-DD HH:mm")}
                    </TableBodyItem>
                    <TableBodyItem>
                      {dayjs(d?.comptime)?.format("YYYY-MM-DD HH:mm")}
                    </TableBodyItem>
                    <TableBodyItem>
                      <LineBtn
                        btnText="보기"
                        btnClickEvent={() => {
                          setDetailData(d);
                          setReportDetailModal(true);
                        }}
                        disabled={!auth?.chat}
                      />
                    </TableBodyItem>
                  </TableBody>
                );
              }
            )}

            {reportDetailModal && (
              <ChatReportDetailModal
                closeEvent={() => setReportDetailModal(false)}
                data={detailData}
                isChatReportCompleteModal={true}
              />
            )}
          </>
        </Table>

        <Pagination
          totalPage={response?.status === 200 ? response.data.totalPage : 10}
          currentPage={page}
          pageClickEvent={(index) => setPage(index)}
          pageSize={response?.status === 200 ? +response?.data?.pageSize : 0}
        />
      </LineBox>

      {loading && <Loader />}
    </ChatSection>
  );
}
